import { reduxForm } from "redux-form";

import { DatosBasicosForm } from "./DatosBasicosForm";

export default reduxForm({
    form: "VisualizarDatosBasicosForm",
})(DatosBasicosForm);
